import React, { useState } from "react";

import Container from "../components/Container";
import SearchTable from "../components/searches/SearchTable";
import UnfinishWorkTableRow from "../components/top/UnfinishWorkTableRow";
import DispatchWorkTableRow from "../components/top/DispatchWorkTableRow";
import Summary from "../components/top/Summary";
import TopHeader from "../components/top/TopHeader";
import { strings } from "../Strings";

/**
 * トップページ
 * @class TopPage
 */
export default function TopPage() {
  const [unfinishedData, setUnfinishedData] = useState([]);
  const [dispatchData, setDispatchData] = useState([]);
  const [search, setSearch] = useState({});
  return (
    <Container title="トップページ" noBackButton>
      <div id="top-page">
        <TopHeader onRefresh={() => setSearch({ ...search })} />
        <Summary unfinishedCount={3} dispatchCount={3} workerName="1234" />

        <section
          className="section section-priority"
          aria-labelledby="unfinished-title"
        >
          <div className="section-head">
            <div className="section-title">
              <span className="section-title-icon" aria-hidden="true">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M9 11h6M9 15h6M8 3h8l3 3v15H5V3h3Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <div>
                <h2 id="unfinished-title">未完了作業一覧</h2>
                <p>現在開始可能、または作業中の指示です</p>
              </div>
            </div>
            <span className="badge-count">{`${unfinishedData.length}件`}</span>
          </div>
          <SearchTable
            header={strings.UNFINISHED_WORK_HEADER}
            path="/unfinished-list"
            data={unfinishedData}
            setData={setUnfinishedData}
            search={search}
          >
            {unfinishedData.map((row) => (
              <UnfinishWorkTableRow
                key={`unfinished${row.id}`}
                workId={row.id}
                startedAt={row.startedAt}
                workplace={row.workplace}
                workType={row.workType}
                modelNumber={row.modelNumberLabel}
                modelType={row.modelTypeLabel}
                workProcess={row.workProcessLabel}
              />
            ))}
          </SearchTable>
        </section>

        <section
          className="section section-planned"
          aria-labelledby="planned-title"
        >
          <div className="section-head">
            <div className="section-title">
              <span className="section-title-icon" aria-hidden="true">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M5 12l4 4L19 6"
                    stroke="currentColor"
                    strokeWidth="2.4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M4 4h16v16H4V4Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinejoin="round"
                    opacity=".65"
                  />
                </svg>
              </span>
              <div>
                <h2 id="planned-title">差立作業一覧</h2>
                <p>今後予定されている作業指示です</p>
              </div>
            </div>
            <span className="badge-count">{`${dispatchData.length}件`}</span>
          </div>
          <SearchTable
            title="差立作業一覧"
            header={strings.DISPATCH_WORK_HEADER}
            path="/dispatch-list"
            data={dispatchData}
            setData={setDispatchData}
            search={search}
          >
            {dispatchData.map((row) => (
              <DispatchWorkTableRow
                key={`dispatch${row.id}`}
                workId={row.id}
                planStartedAt={row.startedAt}
                workplace={row.workplace}
                workType={row.workType}
                modelNumber={row.modelNumberLabel}
                modelType={row.modelTypeLabel}
                workProcess={row.workProcessLabel}
              />
            ))}
          </SearchTable>
        </section>
      </div>
    </Container>
  );
}
